exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".home-care-wrapper{height:100%;width:100%}.home-care-wrapper .home-care-list{display:flex;height:100%;font-family:'Inter', 'Segoe UI', 'Helvetica Neue', 'Arial', sans-serif}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/HomeCare/home-care.scss
// module id = 2004
// module chunks = 33